import mainService from "services/mainService";
import { USERS } from "utils/permissions";

/**
 * @description Busca a lista de profissionais bloqueados no recruta em um estabelecimento
 * @param {Object} params
 * @param {string} params.user
 * @param {number} params.userId
 * @param {number} params.page
 * @param {number} params.pageSize
 * @returns {Promise}
 * @example getBlockedCandidates({ user: "establishment", userId: 1, page: 1, pageSize: 10 });
 */
export const getBlockedCandidates = async ({
  user,
  userId,
  page,
  pageSize,
}) => {
  const params =
    user === USERS.bigcompany ? `${user}/${userId}/units` : `${user}/${userId}`;
  return mainService.get(
    `v2/recruta/${params}/workers_blocked?page=${page}&page_size=${pageSize}`
  );
};

/**
 * @description Desbloqueia um ou múltiplos profissionais no recruta de um estabelecimento
 * @param {Object} params
 * @param {string} params.user
 * @param {number} params.userId
 * @param {Array<number>} params.workerIds
 * @returns {Promise}
 * @example unblockCandidates({ user: "establishment", userId: 1, workerIds: [1, 2, 3] });
 */
export const unblockCandidates = async ({ user, userId, workerIds }) => {
  const params =
    user === USERS.bigcompany ? `${user}/${userId}/units` : `${user}/${userId}`;

  return mainService.delete(`v2/recruta/${params}/workers_blocked`, {
    data: {
      workers: workerIds,
    },
  });
};

/**
 * @description Bloqueia um ou múltiplos profissionais no recruta de um estabelecimento
 * @param {Object} params
 * @param {number} params.establishmentId
 * @param {Array<number>} params.workerIds
 * @returns {Promise}
 * @example blockedCandidates({ establishmentId: 1, workerIds: [1, 2, 3] });
 */
export const blockedCandidates = async ({ establishmentId, workerIds }) => {
  return mainService.post(
    `v2/recruta/establishment/${establishmentId}/workers_blocked`,
    {
      workers: workerIds,
    }
  );
};
